export default __webpack_public_path__ + "static/banner-api-2417c796817d0e2b3e3cb2a09d308af1.png";